import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginService } from '../../services/login/login.services';
import { useUserStore } from '../../utils/userStore';
import { ROUTERS_PATH } from '../../routers/routers';
import { useLayoutContext } from '../../layouts/general-layout';
import './login.scss';

const LoginPage: React.FC = () => {
  const { t } = useLayoutContext();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const setUserInfo = useUserStore((state) => state.setUserInfo);
  const setAttributes = useUserStore((state) => state.setAttributes);
  const loginService = new LoginService();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const response: any = await loginService.login(email, password);
      if (response.success && response.user) {
        setUserInfo({
          id: response.user.id,
          first_name: response.user.first_name,
          last_name: response.user.last_name,
          email: response.user.email,
          phone: response.user.phone,
        });
        setAttributes(response.user.attributes || []);
        navigate(ROUTERS_PATH.PLAYGROUND);
      } else {
        setError(t('loginFailedUserDataMissing'));
      }
    } catch (err: any) {
      setError(err.message || t('loginFailed'));
    }
  };

  return (
    <div className="login-container">
      <h2>{t('login')}</h2>
      <form onSubmit={handleLogin}>
        <input type="email" placeholder={t('email')} value={email} onChange={e => setEmail(e.target.value)} required />
        <input type="password" placeholder={t('password')} value={password} onChange={e => setPassword(e.target.value)} required />
        {error && <div className="error-message">{error}</div>}
        <button type="submit">{t('login')}</button>
      </form>
    </div>
  );
};

export default LoginPage; 